module.exports = __webpack_public_path__ + "static/media/Microsoft Yahei.eb525dcb.ttf";